import { useState } from "react";

const faqs = [
  {
    q: "アイルランドへの留学はビザが必要ですか？",
    a: "90日以内の滞在は観光ビザ不要です。90日を超える語学留学や高校留学の場合は、学生ビザ（Stamp 2）の取得が必要です。ClassLive留学ではビザ申請のサポートも無料で行っています。",
  },
  {
    q: "費用はどれくらいかかりますか？",
    a: "語学留学（3ヶ月）の目安は、学費・ホームステイ・航空券・保険を含めて約60〜80万円程度です。高校留学（1年）の場合は約200〜280万円が目安です。詳しくは無料相談でお見積もりします。",
  },
  {
    q: "英語がほとんど話せなくても大丈夫ですか？",
    a: "基礎は事前に学習しておくことをおすすめしますが、入学時にレベルチェックテストがあり、初心者クラスから始められます。アイルランドの語学学校の先生は初心者への指導経験が豊富です。",
  },
  {
    q: "高校留学は何歳から参加できますか？",
    a: "アイルランドの高校留学プログラムは主に14〜18歳を対象としています。学年の途中からの入学も可能ですが、9月の学年開始に合わせた入学が推奨されます。",
  },
  {
    q: "治安は安全ですか？",
    a: "アイルランドはヨーロッパ有数の安全な国として知られています。特にダブリン市内の留学エリアは治安が良く、女性の一人留学も多いです。現地スタッフがいるので何かあればすぐ相談できます。",
  },
  {
    q: "ClassLive留学の手数料はかかりますか？",
    a: "ClassLive留学のエージェント手数料は完全無料です。学校手配・ビザサポート・出発前オリエンテーション・現地サポートまですべて無料でご利用いただけます。",
  },
  {
    q: "イギリスとアイルランドはどちらがおすすめですか？",
    a: "費用を抑えたい方・EUでの生活を体験したい方・ヨーロッパ旅行も楽しみたい方にはアイルランドがおすすめです。イギリスの有名都市（ロンドン等）にこだわりがある場合はUK版もご覧ください。",
  },
  {
    q: "日本語でのサポートはありますか？",
    a: "はい、ございます。出発前の相談から現地でのトラブル対応まで、日本語で対応しています。ヨーロッパには日本人スタッフも常駐しておりますので、ほぼ24時間での連絡が可能です。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">FAQ</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ❓ よくある質問
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-gray-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-emerald-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 font-bold text-xs flex-shrink-0 mt-0.5">
                    Q
                  </span>
                  <span className="text-sm font-semibold text-gray-800">{faq.q}</span>
                </div>
                <span className="w-5 h-5 flex items-center justify-center text-emerald-500 flex-shrink-0 ml-3">
                  <i className={`${openIndex === i ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`} />
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-amber-100 text-amber-600 font-bold text-xs flex-shrink-0 mt-0.5">
                      A
                    </span>
                    <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
